// extracted by mini-css-extract-plugin
export var box = "_5x-0";
export var check = "_5x-1";
export var checkboxButton = "_5x-6";
export var checkboxGroup = "_5x-5";
export var disabled = "_5x-7";
export var ghost = "_5x-9";
export var input = "_5x-2";
export var label = "_5x-4";
export var normal = "_5x-8";
export var uncheck = "_5x-3";